module.exports = __webpack_public_path__ + "static/img/law-g.7d117b31.png";